import PropTypes from 'prop-types';
export const calculatorFormPropTypes = {
  /**
   * Heading
   */
  heading: PropTypes.string,
  /**
   * Description
   */
  description: PropTypes.string,
  /**
   * Handle submit function
   */
  handleSubmit: PropTypes.func,
  /**
   * Guide
   */
  guide: PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.string
  }),
  /**
   * Label content
   */
  label: PropTypes.string,
  /**
   * Boolean which changes normal radio buttons to buttons with icons
   */
  radioIcon: PropTypes.bool,
  /**
   * Popup data
   */
  popupData: PropTypes.shape({
    heading: PropTypes.string,
    items: PropTypes.array
  }),
  /**
   * Error Message
   */
  errorMsg: PropTypes.string,
  /**
   * Form as an object
   */
  form: PropTypes.shape({
    submit: PropTypes.shape({
      label: PropTypes.string
    }),
    fields: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string,
      placeholder: PropTypes.string,
      required: PropTypes.bool,
      options: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      }))
    }))
  })
};